import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import store from "../../store";
import {toggleUserPopup} from "../../actions/actionFunctions";
import Analytics from './../../analytics';
import {UserPopupTypes} from "../visComponents/constants";
import {toggleShowAssignQuotePopup} from "../../actions/assignPopupFunctions";

class UserLoginButton extends Component {

  static propTypes = {
    className: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      userLogoutActive: false
    }
  }

  static handleLoginClick = ({
                               toggleUserPopup, toggleMobileButton = null,
                               saveQuoteAfterLogin = false, userPopupType = UserPopupTypes.Unlock,
                               checkout = false
                             }) => {
    const state = store.getState();
    const fabricatorSettings = state.fabricatorState.settings;
    // console.log("state.userState.userIsLoggedIn", state.userState.userIsLoggedIn);
    // console.log("state.userState.isPhoneNumberValidated:", state.userState.isPhoneNumberValidated);
    // console.log("fabricatorSettings.twoFA:", fabricatorSettings.twoFA);
    if (state.userState.userIsLoggedIn) {
      if (fabricatorSettings.twoFA) {
        if (!state.userState.isPhoneNumberValidated) {
          toggleUserPopup({userPopupOpened: true, saveQuoteAfterLogin, userPopupType, checkout});
          return false;
        } else {
          if (toggleMobileButton) {
            toggleMobileButton();
            return false;
          }
        }
      } else {
        if (toggleMobileButton) {
          toggleMobileButton();
          return false;
        }
      }

      return true;
    } else {
      if (document.kvConfig.isBackend) {
        store.dispatch(toggleShowAssignQuotePopup(true));
        return false;
      }
      toggleUserPopup({userPopupOpened: true, saveQuoteAfterLogin, userPopupType, checkout});
      if (userPopupType !== UserPopupTypes.NewDesign) {
        window.allowClickLeadCapturePopup = false;
      }
      return false;
    }
  };

  handleUserLoginClick = (userPopupType = UserPopupTypes.Unlock) => {
    Analytics.sendClickEvent('user-login');
    UserLoginButton.handleLoginClick({...this.props, toggleMobileButton: this.toggleMobileButton, userPopupType})
  };

  toggleMobileButton = () => {
    this.setState({
      userLogoutActive: !this.state.userLogoutActive
    }, () => {
      setTimeout(() => {
        this.state.userLogoutActive
          ? window.addEventListener('click', this.handleDropdownWrapperBlur)
          : window.removeEventListener('click', this.handleDropdownWrapperBlur)
      }, 0)
    })
  };

  handleDropdownWrapperBlur = (e) => {
    const questionLogout = e.target.closest('[class*="scart-content__question"]');
    if (!questionLogout) {
      this.toggleMobileButton();
    }
  };

  handleLogOutButtonClick = (logout) => {
    Analytics.sendClickEvent('user-logout');
    if (logout) {
      this.props.toggleUserPopup({
        userPopupOpened: false,
        userIsLoggedIn: false,
        isPhoneNumberValidated: false
      });
    }
    this.toggleMobileButton()
  };

  render() {
    return (
      <div className={"materials-buttonWrapper " + (this.props.className || '')}>
        <button
          className={"materials-button materials-button--user" + (this.state.userLogoutActive ? " materials-button--active" : "")}
          onClick={() => this.handleUserLoginClick()}>
          <span className="materials-button__text">
            {this.props.userIsLoggedIn
              ? <FormattedMessage id={"userLoginButton.logOut"}/>
              : <FormattedMessage id={"userLoginButton.logIn"}/>}
          </span>
        </button>
        <div className={"scart-dropdown" + (this.state.userLogoutActive ? " scart-dropdown--opened" : "")}>
          <div className="scart-content__question">
            <p className="scart-content__question-text"><FormattedMessage id={"userLoginButton.logoutQuestion"}/></p>
            <div className="scart-content__question-buttons">
              <button className="ui-button2 ui-button2--white" onClick={() => this.handleLogOutButtonClick(true)}>
                <FormattedMessage id={"userLoginButton.logoutQuestionYes"}/>
              </button>
              <button className="ui-button2 ui-button2--white" onClick={() => this.handleLogOutButtonClick(false)}>
                <FormattedMessage id={"userLoginButton.logoutQuestionNo"}/>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    userIsLoggedIn: store.userState.userIsLoggedIn,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    fabricatorSettings: store.fabricatorState.settings,
  };
};

export default connect(mapStateToProps, {
  toggleUserPopup,
  toggleShowAssignQuotePopup
})(UserLoginButton);
